












































































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import SectionWrappe from "@/components/section/SectionWrappe.vue";
import * as types from "@/store/constants/types";
import VideoPlayer from "@/components/videoPlayer/videoPlayer.vue";
import EventBus from "@/utils/eventBus";
import SuperPayAndBackUpHelpers, {
  TEMP_KEY,
  LOCAL_KEY
} from "@/utils/superPayAndBackUp";
import BakcPress, { SUPER_PAY_TOAST } from "@/utils/backPress";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
    SectionWrappe,
    VideoPlayer
  }
})
export default class SuperPayDialog extends Vue {
  @Getter(types.GETTER_SUPER_PAY_APP_CONFIG)
  private superPayAppConfig: any;
  @Getter(types.GETTER_SUPER_PAY_PARAMS)
  private superPayAppParams: any;
  @Getter(types.GETTER_SUPER_PAY_SHOW_ENABLE)
  private superPayShowEnable: any;
  @Action(types.START_INSTALL_SUPER_PAY_APP)
  private startInstallSuperPayApp: any;
  @Action(types.FETCH_VIDEO_URL_BY_DICT)
  private getVideoURL: any;
  @Getter(types.GETTER_SUPER_PAY_APP_DESC_LIST)
  private superPayAppDescList: any;

  private videoSrc: string = "";
  private swiperTimer: any = null;
  private tempVal: any = null;

  private swiperOption: any = {
    // some swiper options/callbacks
    // 所有的参数同 swiper 官方 api 参数
    // ...
    autoplay: false,
    // loop: true,
    pagination: {
      el: ".super-pay-dialog-swiper-pagination"
    },
    on: {
      slideChangeTransitionEnd: () => {
        if (this.mySwiper) {
          console.log("this.tabsArrIndex", this.mySwiper.activeIndex);
          if (this.mySwiper.activeIndex === 0) {
            this.replayVideo();
          }
        }
      }
    }
  };

  private superPayDialogShow: boolean = false;
  private closeFn: any = () => {};

  get iconUrl() {
    return this.superPayAppConfig.iconUrl;
  }

  get mySwiper() {
    return this.$refs.suerPaySwiper && (this.$refs.suerPaySwiper as any).swiper;
  }

  get reward() {
    return this.superPayAppConfig.reward;
  }

  get title() {
    return this.superPayAppConfig.appName;
  }

  get poster() {
    return require("@/assets/icons-file/super_pay/super_video_face.png");
  }

  get listData() {
    return this.superPayAppDescList();
  }

  get sectionListData() {
    return [
      {
        title: "Lorem ipsum dolor",
        content:
          "Lorem ipsum dolor sit amt, consect adipisicing elit, sed do eiusmod tempor"
      },
      {
        title: "Lorem ipsum dolor",
        content:
          "Lorem ipsum dolor sit amt, consect adipisicing elit, sed do eiusmod tempor"
      }
    ];
  }

  get superPayShow() {
    return this.superPayShowEnable;
  }

  get mySwiperTimer() {
    return this.swiperTimer;
  }

  private replayVideo() {
    console.log("replayVideo:", this.mySwiperTimer);
    clearInterval(this.mySwiperTimer);

    this.$refs.videoPlayer &&
      (this.$refs.videoPlayer as any).reforceReplayVideo();
  }

  private startAutoMoveSwiper() {
    (this.mySwiper as any).slideNext();
    this.swiperTimer = setInterval(() => {
      (this.mySwiper as any).slideNext();

      if (this.mySwiper.activeIndex === 1) {
        setTimeout(() => {
          (this.mySwiper as any).slideTo(0);
        }, 3000);
        clearInterval(this.mySwiperTimer);
      }
    }, 3000);
  }

  private endedVideo() {
    console.log("endedVideo:");
    this.startAutoMoveSwiper();
  }

  private clickClose() {
    this.closeFn ? this.closeFn() : void 0;
    this.superPayDialogShow = false;

    clearInterval(this.swiperTimer);

    BakcPress.destroy(SUPER_PAY_TOAST);
  }

  private clickMask() {
    this.clickClose();
  }

  private clickRecommend() {
    this.startInstallSuperPayApp({
      ga: this.tempVal.ga
    });
    this.superPayDialogShow = false;
  }

  private created() {}

  private async mounted() {
    EventBus.$on("show-super-pay-toast", (val: any) => {
      if (val.show) {
        this.tempVal = val;

        this.superPayDialogShow = true;

        if (val.ga && val.ga === "pay_result_close") {
          console.log("SUPER_PAY_PAY_RESULT_CLOSE_SHOW_TIMES+1");
          SuperPayAndBackUpHelpers.addLocalKeyTimes(
            LOCAL_KEY.SUPER_PAY_PAY_RESULT_CLOSE_SHOW_TIMES
          );
        }

        if (val.ga) {
          sendEventWithParams("uia_recommend_app_show", {
            super_pay: val.ga
          });
        }

        BakcPress.listen({
          key: SUPER_PAY_TOAST,
          fn: () => {
            this.clickClose();
          }
        });
      } else {
        this.superPayDialogShow = false;
      }

      if (val.closeFn) {
        this.closeFn = val.closeFn;
      }
    });

    if (this.superPayAppParams) {
      this.videoSrc = await this.getVideoURL(
        this.superPayAppParams.video_files.pay_or_result_page_dialog
      );
    }
  }
}
